import React, { useState } from 'react';
//import NavbarDropdown from './NavbarDropdown';
//import { dashboardRoutes, appRoutes, pagesRoutes, modulesRoutes, documentationRoutes } from 'routes/siteMaps';
import { Dropdown, Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//import { flatRoutes } from 'helpers/utils';
//import NavbarDropdownApp from './NavbarDropdownApp';
//import NavbarDropdownPages from './NavbarDropdownPages';
//import NavbarDropdownModules from './NavbarDropdownModules';
//import AppContext from 'context/Context';

import PropTypes from 'prop-types';
import AuthCornerImage from 'assets/img/illustrations/authentication-corner.png';
import { breakpoints, capitalize, getFlatRoutes } from 'helpers/utils';
import { topNavbarBreakpoint } from 'config';

import NavbarNavLink from './NavbarNavLink';
import NavbarNavLinks from './NavbarNavLinks';
import { contextApp } from 'context';

/* const routes = [
 {
  id: 'MKDTgOWFz3Kl-V-pVHApF',
  name: 'app',
  label: 'App',
  active: true,
  children: [
   {
    id: 'nA-ie3kYhx0YdHtuDnhX0',
    name: 'Calendar',
    to: '/1/app/calendar',
    icon: 'calendar-alt',
    active: true,
    allow: [],
    permits: []
   },
   {
    id: '535fjjjd-2IOkI9394-744',
    name: 'Orders',
    icon: 'shopping-cart',
    to: '/1/app/orders',
    active: true,
    allow: [],
    permits: []
   }
  ]
 },
 {
  id: '5eqeoAXQqV7CbgtxwnZju',
  name: 'settings',
  label: 'Settings',
  active: true,
  children: [
   {
    id: '5iysBwK2IOkI883rV_x',
    name: 'Company',
    icon: 'chart-pie',
    to: '/1/settings/company',
    active: true,
    allow: [],
    permits: []
   },
   {
    id: '5iysBwK2IOkI9394-744',
    name: 'Project',
    icon: 'shapes',
    to: '/1/settings/projects',
    active: true,
    allow: [],
    permits: []
   },
   {
    id: 'bpc9739zGADivjuC55',
    name: 'Contracts',
    icon: 'file-signature',
    to: '/1/settings/contracts',
    active: true,
    allow: [],
    permits: [
     {
      name: 'Editar Categorias',
      description: 'podra editar todas las rutas de cualquier categoria',
      allow: 'bpcsCj7_e94asJKjuC55'
     },
     {
      name: 'Crear Categorias',
      description: 'podra editar todas las rutas de cualquier categoria',
      allow: 'bpcsCj7_e94asJKjuC66'
     },
     {
      name: 'Eliminar Categorias',
      description: 'podra editar todas las rutas de cualquier categoria',
      allow: 'bpcsCj7_e94asJKjuC77'
     }
    ]
   },
   {
    id: 'bpcsCjrtzGADivJKjuC55',
    name: 'Routes',
    icon: 'route',
    to: '/1/settings/routes',
    active: true,
    allow: [],
    permits: [
     {
      name: 'Editar Categorias',
      description: 'podra editar todas las rutas de cualquier categoria',
      allow: 'bpcsCj7_e94asJKjuC55'
     },
     {
      name: 'Crear Categorias',
      description: 'podra editar todas las rutas de cualquier categoria',
      allow: 'bpcsCj7_e94asJKjuC66'
     },
     {
      name: 'Eliminar Categorias',
      description: 'podra editar todas las rutas de cualquier categoria',
      allow: 'bpcsCj7_e94asJKjuC77'
     }
    ]
   }
  ]
 }
]; */

const NavbarDropdown = ({ title, children }) => {
 const [dropdownOpen, setDropdownOpen] = useState(false);

 return (
  <Dropdown
   show={dropdownOpen}
   onToggle={() => setDropdownOpen(!dropdownOpen)}
   onMouseOver={() => {
    let windowWidth = window.innerWidth;
    if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
     setDropdownOpen(true);
    }
   }}
   onMouseLeave={() => {
    let windowWidth = window.innerWidth;
    if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
     setDropdownOpen(false);
    }
   }}
  >
   <Dropdown.Toggle as={Link} to="#!" className="nav-link fw-semi-bold">
    {capitalize(title)}
   </Dropdown.Toggle>
   <Dropdown.Menu className="dropdown-menu-card mt-0 dropdown-caret">
    <Card className="shadow-none dark__bg-1000">
     <Card.Body className="scrollbar max-h-dropdown">
      <img src={AuthCornerImage} alt="" className="img-dropdown" width={70} />
      {children}
     </Card.Body>
    </Card>
   </Dropdown.Menu>
  </Dropdown>
 );
};

NavbarDropdown.propTypes = { title: PropTypes.string.isRequired, children: PropTypes.node };

const NavbarDropdowns = ({ items }) => {
 const routes = getFlatRoutes(items);

 return (
  <Row>
   {Object.entries(routes).map(([name, val], i) => (
    <Col xs={12} key={i}>
     {name !== 'Otros' && <NavbarNavLink title={name} />}
     <NavbarNavLinks routes={val} />
    </Col>
   ))}
  </Row>
 );
};

NavbarDropdowns.propTypes = {
 items: PropTypes.arrayOf(
  PropTypes.shape({
   icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
   name: PropTypes.string.isRequired,
   to: PropTypes.string,
   children: PropTypes.array
  }).isRequired
 ).isRequired
};

const NavbarTopDropDownMenus = () => {
 const {
  routes
  /* setConfig, */
  /* config: {
   navbarCollapsed, showBurgerMenu 
  } */
 } = contextApp();

 /* const handleDropdownItemClick = () => {
  if (navbarCollapsed) {
   setConfig('navbarCollapsed', !navbarCollapsed);
  }
  if (showBurgerMenu) {
   setConfig('showBurgerMenu', !showBurgerMenu);
  }
 }; */
 return (
  <>
   {routes.map((e /* i */) => (
    <NavbarDropdown key={e.id} title={e.name}>
     <NavbarDropdowns items={e.children} />
    </NavbarDropdown>
   ))}

   {/* <NavbarDropdown title="dashboard">
    {dashboardRoutes.children[0].children.map(route => (
     <Dropdown.Item
      key={route.name}
      as={Link}
      className={route.active ? 'link-600' : 'text-500'}
      to={route.to}
      onClick={handleDropdownItemClick}
     >
      {route.name}
     </Dropdown.Item>
    ))}
   </NavbarDropdown>

   <NavbarDropdown title="app">
    <NavbarDropdownApp items={appRoutes.children} />
   </NavbarDropdown>

   <NavbarDropdown title="pages">
    <NavbarDropdownPages items={pagesRoutes.children} />
   </NavbarDropdown>
   <NavbarDropdown title="modules">
    <NavbarDropdownModules items={modulesRoutes.children} />
   </NavbarDropdown>

   <NavbarDropdown title="documentation">
    {flatRoutes(documentationRoutes.children).map(route => (
     <Dropdown.Item
      key={route.name}
      as={Link}
      className={route.active ? 'link-600' : 'text-500'}
      to={route.to}
      onClick={handleDropdownItemClick}
     >
      {route.name}
     </Dropdown.Item>
    ))}
   </NavbarDropdown> */}
  </>
 );
};

export default NavbarTopDropDownMenus;
